import React from 'react'
import { useTranslation } from '../../hook/useTranslation'
import { useSubmitDashboardQuery } from '../../hook/useQuery'
import {DEFAULT_DASHBOARD_QUERY_ARGS} from '../../data/defaults'
import { useUiDashboardQuery } from '../../hook/useUi'

const QueryDashboardButton = ()=>{
    const {
        button_submit
    } = useTranslation("dashboard")
    const [isLoading, submit] = useSubmitDashboardQuery()

    return <div>
        <button className={"button button-primary"} disabled={isLoading} onClick={submit}>{button_submit}</button>
    </div>
}

export default QueryDashboardButton

export const QueryDashboardResetButton = ()=>{
    const {
        button_reset
    } = useTranslation("dashboard")
    const [_, setQuery] = useUiDashboardQuery()
    const [isLoading] = useSubmitDashboardQuery()

    const handleReset = ()=>{
        setQuery(DEFAULT_DASHBOARD_QUERY_ARGS)
    }

    return <div>
        <button className={"button button-secondary"} disabled={isLoading} onClick={handleReset}>{button_reset}</button>
    </div>

}
